module.exports = __webpack_public_path__ + "img/hr-roboport-door-up.ad3f8d78.png";